import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';
import styled from 'styled-components'
import { ToastContainer } from 'react-toastify'
import PrivateRoute from './private';
import { AuthContext } from '../contexts/AuthContext'
import Header from '../components/Header';
import Sidebar from '../components/Sidebar'
import Login from "../views/Login";
import Register from "../views/Register";
import RecoverPassword from "../views/RecoverPassword";
import CreateNewPassword from "../views/CreateNewPassword";
import Dashboard from "../views/Dashboard"
import Course from "../views/Course"
import Classe from "../views/Classe"
import LectureExams from "../views/LectureExams"
import LectureAnswers from "../views/LectureAnswers"
import Profile from "../views/Profile"
import BuyCourse from "../views/BuyCourse"
import Highlighter from "../views/Highlighter";

const StyledContainer = styled.div`
height: 90vh;
overflow: auto;
display: flex;
flex-direction: row;
width: 100%;
`

const Content = styled.div`
background-color: rgba(255, 255, 255, 1);
overflow: auto;
width: 100%;
`

const Routes = (props) => {
  const { auth } = React.useContext(AuthContext);
  return <BrowserRouter>
    <Header />
    <ToastContainer
      position="top-right"
      autoClose={10000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      draggable
      pauseOnHover
    />
    <BlockUi tag="div" blocking={auth.isLoading} loader={<Loader active type="line-scale-party" color="#296ba9" />} >
      <StyledContainer>
        <Sidebar />
        <Content>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/buy/:id" component={BuyCourse} /> 
            <Route path="/register" component={Register} />
            <Route path="/recover-password" component={RecoverPassword} />
            <Route path="/create-new-password/:token" component={CreateNewPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <PrivateRoute exact path="/course/:courseId/class/:classId/exams/:id" component={LectureExams} />
            <PrivateRoute exact path="/course/:courseId/class/:classId/answers/:id" component={LectureAnswers} />
            <PrivateRoute exact path="/course/:courseId/class/:id" component={Classe} />
            <PrivateRoute exact path="/course/:id" component={Course} />
            <PrivateRoute exact path="/profile" component={Profile} />
            <PrivateRoute exact path="/course/:courseId/class/:classId/highlighter/:id" component={Highlighter} />
          </Switch>
        </Content>
      </StyledContainer>
    </BlockUi>
  </BrowserRouter>
};

export default Routes;
